/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('DeclarationsCtrl', function($scope, identity, Log, ngNotify) {
    $scope.error = {
        start: false,
        end:   false
    };
    $scope.date  = {
        start: null,
        end:   null
    };

    $scope.findDeclarationsByDate = function() {
        $scope.error.start = ($scope.date.start == null) ? true : false;
        $scope.error.end   = ($scope.date.end == null)   ? true : false;

        if ([$scope.error.start, $scope.error.end].includes(true)) { return; }

        const start = $scope.date.start.format('YYYY-MM-DD');
        const end   = $scope.date.end.format('YYYY-MM-DD');

        return findDeclarations(start, end);
    };

    var findDeclarations = function(start = null, end = null) {
        if (true === $scope.loading) { return; }
        $scope.loading = true;

        return Log
        .getDeclarations({
            login: identity.login,
            start,
            end}).$promise
        .then(declarations => $scope.declarations = declarations.hits.map(function(declaration) {
            declaration.status = (() => { switch (true) {
                case (declaration.metas.cancel_message != null): return 'canceled';
                case (declaration.metas.warn_message != null):   return 'warning';
                default: return 'valid';
            } })();
            return declaration;
        })).catch(() => ngNotify.set('Erreur lors de la récupération des déclarations.', 'error')).finally(() => $scope.loading = false);
    };

    return findDeclarations();
});
